
<style scoped>
.wrapUn {
  display: flex;
  flex-direction: column;
}
main {
  flex: 1;
  display: flex;
  padding: 10px;
}
.pieChart {
  flex: 3.5;
}
.table {
  flex: 6.5;
  overflow: auto;
}
.car-t {
  width: 55%;
  display: flex;
  align-content: space-around;
  align-items: center;
}
</style>

<template>
  <div style="background:#fff;border-radius:10px;height:101%;" class="wrapUn">
    <exportDate v-if="showExport" :provCode="conditon.provCode" :city="conditon.city" :range="conditon.range" :defaultTab="defaultTab" @hideExport="hideExport1" :moduleName="moduleName" />
    <Form :conditon="conditon" :provinceList="provinceList" :cityList="cityList" :title="title" :search="search" :prev="prev" :changeCity="changeCity">
      <Season slot="season" :getValue="getValue" :defaultValue="conditon.time" />
      <el-button @click="exportDate1" slot="export" v-show="hideExport">导出</el-button>
    </Form>
    <main>
      <PieChart :subtext="subtext" :pieData="pieData" />
      <div class="car-t">
        <Table :tableData="tableData" :toDetail="toDetail" :changePie="changePie">
          <TabTitle :title="titleArr" :defaultTab="defaultTab" :changeTab="changeTab" slot="title" />
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage3" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" slot="pagin"></el-pagination>
        </Table>
      </div>
    </main>
  </div>
</template>
<script>
/**
 * @file:  View 组件 form
 * @author: v_chengmengya
 * @date: 2019-05-15
 * @description: 停靠非石化加油站企业列表
 */
import Form from './components/form' // from表单
import PieChart from './components/pieChart' // 饼状图
import Table from './components/table' // 表格
import TabTitle from './components/tabTitle' // 表格排序tab切换
import exportDate from '@/components/exportDate/quarter' // 月份选择
import Season from './components/season' // 季度选择
import http from '@/api/freight' // 请求汇总
import { hideExport } from '@/utils/tools'
import { getBaseGasStationArray } from '@/utils/dictionary'
import map from 'lodash/map'
export default {
  components: {
    Form,
    PieChart,
    Table,
    TabTitle,
    exportDate,
    Season,
  },
  data() {
    let arr = getBaseGasStationArray()
    let pieData = map(arr, (name) => {
      return {
        name,
        value: 0,
      }
    })
    return {
      hideExport: hideExport,
      title: '停靠非石化加油站企业列表',
      tableData: [], // 表格数据
      conditon: {
        // 表单数据
        time: '',
        pvovince: '',
        city: '',
        range: '',
        provCode: '',
      },
      provinceList: [], // 省份数据
      cityList: [], // 联动地市数据
      subtext: '',
      /*pieData: [
        {
          name: '中国石化',
          value: 0
        },
        {
          name: '中国石油',
          value: 0
        },
        {
          name: '其他油站',
          value: 0
        }
      ],*/
      pieData,
      titleArr: [
        {
          name: '按车辆数降序排列 ↓',
          value: 'vehicleCount',
        },
        {
          name: '按非石化油站停靠次数降序排列 ↓',
          value: 'petroleumStopCount',
        },
        {
          name: '按其运营公里数降序排列 ↓',
          value: 'mileage',
        },
      ],
      defaultTab: 'mileage', // 默认tab
      currentPage3: 1,
      total: 0,
      pageSize: 10,
      showExport: false,
      moduleName: 'companyDetail',
    }
  },
  watch: {
    'conditon.date': function (value, oldValue) {
      // 父组件监听子组件数据
    },
  },
  methods: {
    //导出
    exportDate1() {
      // console.log(this.conditon.provCode)
      // if (!this.conditon.provCode) {
      //   this.$message({
      //     message: '请选择省份',
      //     type: 'warning'
      //   })
      //   return
      // }
      this.showExport = true
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    initDate(num = 2) {
      let that = this
      if (num == 2 && this.conditon.time == '') {
        this.$message({
          message: '请选择日期',
          type: 'warning',
        })
        return
      }
      // 初始化数据
      http
        .carUnpetrifiedCom({
          provCode: that.conditon.provCode ? that.conditon.provCode : null,
          cityCode: that.conditon.city ? that.conditon.city : null,
          order: that.defaultTab ? that.defaultTab : null,
          percentage: that.conditon.range ? that.conditon.range : null,
          isfirst: num,
          time: that.conditon.time,
          page: that.currentPage3,
          pageSize: that.pageSize,
        })
        .then((e) => {
          if (e.code == 200 && e.data.tPageUtil && e.data.tPageUtil.list) {
            let arr = e.data.tPageUtil.list.slice(0)
            that.tableData = arr
            that.total = e.data.tPageUtil.count
            that.currentPage3 = e.data.tPageUtil.pageNum
            that.conditon.time = e.data.conTime
            that.subtext = ''
            if (arr.length > 0) {
              let petrochemicalStopCount = arr[0].petrochemicalStopCount
              let petroleumStopCount = arr[0].petroleumStopCount
              let otherStopCount = arr[0].otherStopCount
              let companyName = arr[0].companyName
              that.changePie({
                petrochemicalStopCount,
                petroleumStopCount,
                otherStopCount,
                companyName,
              })
            } else {
              let petrochemicalStopCount = 0
              let petroleumStopCount = 0
              let otherStopCount = 0
              let companyName = ''
              that.changePie({
                petrochemicalStopCount,
                petroleumStopCount,
                otherStopCount,
                companyName,
              })
            }
          } else {
            that.tableData = []
          }
        })
    },
    search() {
      this.currentPage3 = 1
      this.total = 0
      this.initDate(2)
    },
    toDetail(id) {
      let that = this
      this.$router.push({
        name: 'carUnpetrifiedDetail',
        query: {
          companyName: id,
          time: that.conditon.time,
        },
      })
    },
    changeTab(value) {
      this.currentPage3 = 1
      // 表格排序切换
      this.defaultTab = value
      this.initDate(2)
    },
    handleCurrentChange(index) {
      // 翻页 参数为页码
      this.currentPage3 = index
      this.initDate(2)
    },
    changePie({
      petrochemicalStopCount,
      petroleumStopCount,
      otherStopCount,
      companyName,
    }) {
      //  饼状图切换
      let that = this
      setTimeout(() => {
        let arr = that.pieData.slice(0)
        arr[0].value = petrochemicalStopCount
        arr[1].value = petroleumStopCount
        arr[2].value = otherStopCount
        that.pieData = arr.slice(0)
        that.subtext = companyName
      })
    },

    prev() {
      // 返回上级
      this.$router.push({
        name: 'carStopBrand',
      })
    },
    getPrev() {
      let that = this
      http.carUnpetrifiedComProv().then((e) => {
        if (e.code == 200 && e.data) {
          that.provinceList = [...e.data]
        }
      })
    },
    changeCity(provname) {
      if (!provname) {
        this.conditon.provCode = null
        this.conditon.city = null
        return false
      }
      let that = this
      http
        .carTrainsDetailCity({
          provname: provname.split('-')[0],
        })
        .then((e) => {
          if (e.code == 200 && e.data.length) {
            that.cityList = e.data.slice(0)
          }
          that.conditon.provCode = provname.split('-')[1]
        })
    },
    // 季度监听
    getValue(time) {
      let that = this
      that.conditon.time = time
    },
    exportDate() {
      this.showExport = true
    },
  },
  mounted() {
    this.getPrev()
    this.initDate(1)
  },
}
</script>